module.exports = __webpack_public_path__ + "06e6ee07d14482d31f3ab8b0e830b2f6.jpg";